//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Success',
  props: {
    maatwerkroute: {
      type: Boolean,
      default: false,
    },
    done: {
      type: Boolean,
      default: false,
    },
    idealLink: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    headerImg: require('~/assets/img/lid-worden.jpg'),
  }),
};
